import React, { useLayoutEffect } from 'react'
import { RFNoDistractionsHeader, NavType } from '@chegg-me-components/header'
import { Config } from '@chegg-wt/core/config'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { publicAssetUrl, publicUrl } from '@chegg-wt/core/utils/url'
import { LocationCopy } from '@chegg-wt/core/types/core'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import { AppLink } from '../AppLink'
import { LocationNavBar } from '../LocationNavBar'
import { RF_NO_DISTRACTIONS, SITE_LOGO } from './testIds'

import * as Styled from './styled'

interface Props {
  children?: React.ReactNode
  copy?: LocationCopy[]
  backgroundThroughGam?: boolean
}

const AuthLayout: React.FC<Props> = ({ copy, children, backgroundThroughGam }) => {
  useLayoutEffect(() => {
    if (!backgroundThroughGam) {
      const imgFilename = 'auth-bg.jpg'
      const imgUrl = publicAssetUrl(imgFilename)
      document.body.style.background = `url("${imgUrl}") center center / cover no-repeat fixed`

      return () => {
        document.body.style.background = ''
      }
    }
  }, [backgroundThroughGam])

  const { toCitationsHome } = useRoutesContext()

  const wrappedChildren = <main>{children}</main>

  return Config.useCheggMeHeaders ? (
    <Styled.RfNoDistractionContainer>
      <RFNoDistractionsHeader
        envUrl={routeToHref(toCitationsHome())}
        navType={NavType.writing}
        mainContentId="__next"
        data-test={RF_NO_DISTRACTIONS}
      />
      {wrappedChildren}
    </Styled.RfNoDistractionContainer>
  ) : (
    <Styled.Container>
      <AppLink route={toCitationsHome()}>
        <a data-test={SITE_LOGO}>
          <Styled.Logo
            alt={`${Config.siteName} Logo`}
            src={publicUrl('/static/logo.svg')}
          />
        </a>
      </AppLink>
      {copy && <LocationNavBar copy={copy} />}
      {wrappedChildren}
    </Styled.Container>
  )
}

export default AuthLayout
